import {
  FaInstagram,
  FaTwitter,
  FaPhone,
  FaFacebook,
  FaApple,
  FaEnvelope,
} from "react-icons/fa";
import SubHeader from "./SubHeader";

export default function Header() {
  return (
    <>
      <header className="bg-dark text-white">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-sm-4 col-xs-12">
              <p>
                <FaPhone color="#28A7E9" />
                <span> Phone</span>+91 6392369997
              </p>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12">
              <p>
                <FaEnvelope color="#28A7E9" />
                <span>Email</span>gehalotkishan@gmail.com
              </p>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12">
              <ul className="social-icon">
                <li>
                  <span>Meet me on</span>
                </li>
                <li className="ml-2">
                  <FaFacebook />
                </li>
                <li className="ml-2">
                  <FaTwitter />
                </li>
                <li className="ml-2">
                  <FaInstagram />
                </li>
                <li className="ml-2">
                  <FaApple />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      <SubHeader />
    </>
  );
}
